








































import Vue from "vue";
import { Form } from "element-ui";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "Invite",
  props: { projectId: { type: String }, tenantId: { type: String } },
  data() {
    return {
      dialog: false,
      roleOptions: [
        {
          value: "PROJECT_ADMIN",
          name: "项目管理员"
        },
        {
          value: "PROJECT_REGULAR",
          name: "普通用户"
        }
      ],
      form: {
        userName: "",
        userId: "",
        role: ""
      },
      rules: {
        role: [{ required: true, message: "请选择角色", trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions("PrjMembers", ["updataUserRole"]),
    show(data: any) {
      this.form = Object.assign(
        {},
        { userName: data.userName, userId: data.userId, role: data.role }
      );
      this.dialog = true;
    },
    quit() {
      (this.$refs.form as Form).resetFields();
      this.dialog = false;
    },
    submit() {
      (this.$refs.form as any).validate((valid: any) => {
        if (valid) {
          this.updataUserRole({
            tenantId: this.tenantId,
            projectId: this.projectId,
            userId: this.form.userId,
            role: this.form.role
          });
          this.quit();
        }
      });
    }
  }
});
